import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { StyleSheet, View } from 'react-native';
import { Camera, useCameraDevice, useCodeScanner } from 'utils/packages/Camera';
import { useAppState } from 'hooks';
export default React.memo(({ visible, flash, onScannedCodes }) => {
    const camera = useRef(null);
    const device = useCameraDevice('back');
    const appState = useAppState();
    const isForeground = useMemo(() => visible && appState === 'active', [visible, appState]);
    const [isInitialized, setIsInitialized] = useState(false);
    const timeoutRef = useRef(undefined);
    const onInitialized = useCallback(() => {
        timeoutRef.current = setTimeout(() => {
            setIsInitialized(true);
        }, 300);
    }, []);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    const codeScanner = useCodeScanner({
        codeTypes: ['qr'],
        onCodeScanned: (barcodes) => {
            if (onScannedCodes) {
                onScannedCodes(barcodes
                    .filter((code) => code.value !== undefined)
                    .map((code) => code.value));
            }
        },
    });
    return device ? (<>
      <Camera ref={camera} style={StyleSheet.absoluteFill} device={device} torch={isForeground && flash ? 'on' : 'off'} isActive={isForeground} codeScanner={codeScanner} onInitialized={onInitialized}/>
      {!isInitialized && (<View style={[StyleSheet.absoluteFill, styles.blackOverlay]}/>)}
    </>) : null;
});
const styles = StyleSheet.create({
    blackOverlay: { backgroundColor: 'black' },
});
